import { fromJS } from "immutable";
import {
  GET_VISIBILITY,
  SET_GROUP_VISIBILITY,
  SET_SETTING_VISIBILITY,
  VISIBILITY_CHANGED,
  VISIBILITY_FAILED,
} from "./constants";

export const initialState = fromJS({
  accountId: null,
  // settled: the read finished either way, so the panel may render.
  // fetched: it succeeded, so the lists are real and safe to write back —
  // persisting without it would wipe the stored policy.
  settled: false,
  fetched: false,
  hiddenGroups: [],
  hiddenSettings: [],
});

const toggleKey = (list, key, hidden) => {
  if (hidden) return list.includes(key) ? list : list.push(key);
  return list.filter((k) => k !== key);
};

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case GET_VISIBILITY:
      // Another account: drop it, so nothing stays hidden from the old policy.
      if (state.get("accountId") !== action.accountId)
        return initialState.set("accountId", action.accountId);
      // After a failed read, unsettle again so the retry shows the loading
      // state instead of an unfiltered configuration.
      return state.get("fetched") ? state : state.set("settled", false);
    case VISIBILITY_CHANGED:
      return initialState
        .set("accountId", action.accountId)
        .set("settled", true)
        .set("fetched", true)
        .set("hiddenGroups", fromJS(action.visibility?.hiddenGroups || []))
        .set("hiddenSettings", fromJS(action.visibility?.hiddenSettings || []));
    case VISIBILITY_FAILED:
      // Fail open, but leave `fetched` false so the next open retries and no
      // write can happen meanwhile.
      return initialState
        .set("accountId", action.accountId)
        .set("settled", true);
    case SET_GROUP_VISIBILITY:
      return state.update("hiddenGroups", (l) =>
        toggleKey(l, action.group, !action.visible)
      );
    case SET_SETTING_VISIBILITY:
      return state.update("hiddenSettings", (l) =>
        toggleKey(l, action.setting, !action.visible)
      );
    default:
      return state;
  }
}
